import store from '../../store';

const $ = jQuery;

export const META_STORE_STATUS = 'META_STORE_STATUS';
export const META_STORE_FORM = 'META_STORE_FORM';
export const META_CLEAR_SOBJECT = 'META_CLEAR_SOBJECT';
export const META_STORE_SOBJECT_NAME = 'META_STORE_SOBJECT_NAME';
export const META_STORE_SOBJECT_FIELDS = 'META_STORE_SOBJECT_FIELDS';
export const META_STORE_FEED_ID = 'META_STORE_FEED_ID';
export const META_STORE_UPDATE_DUPES = 'META_STORE_UPDATE_DUPES';
export const META_STORE_IDENTITY_FIELD = 'META_STORE_IDENTITY_FIELD';
export const META_UPDATE_DUPES_HYDRATE = 'META_UPDATE_DUPES_HYDRATE';

export const metaUpdateDupesHydrate = update_dupes => ({
    type: META_UPDATE_DUPES_HYDRATE,
    update_dupes,
});

export const metaStoreUpdateDupes = (sobjectName, enabled) => ({
    type: META_STORE_UPDATE_DUPES,
    sobjectName,
    enabled
});

export const metaStoreIdentityField = (sobjectName, identity_field) => ({
    type: META_STORE_IDENTITY_FIELD,
    sobjectName,
    identity_field
});

export const metaStoreStatus = status => ({
    type: META_STORE_STATUS,
    status
});

export const metaStoreForm = form => ({
    type: META_STORE_FORM,
    form
});

export const metaClearSobject = () => ({
    type: META_CLEAR_SOBJECT,
});

export const metaStoreFeedId = feed_id => ({
    type: META_STORE_FEED_ID,
    feed_id
});

export const metaStoreSobjectName = sobject => ({
    type: META_STORE_SOBJECT_NAME,
    name: sobject,
});

export const metaStoreSobjectFields = fields => ({
    type: META_STORE_SOBJECT_FIELDS,
    fields,
});

export const getSalesforceObjectFields = sobject => {
    return $.post(ajaxurl, {
        'action': 'via_load_sf_field_map',
        sobject,
        viagf_nonce,
    });
};

export const loadSalesforceObjectFields = sobject => {
    const { dispatch } = store;

    dispatch(metaClearSobject());
    dispatch(metaStoreSobjectName(sobject));

    getSalesforceObjectFields(sobject)
        .then(resp => {
            const { fields, status, msg } = $.parseJSON(resp);

            if (status == 'ok') {
                dispatch(metaStoreSobjectFields(fields));
            } else {
                //TODO - handle errors here
            }
        });
};

export const saveStore = () => {
    const state = store.getState();

    return $.ajax({
        url: ajaxurl,
        type: 'POST',
        async: false,
        data: {
            action: 'via_save_sf_field_map',
            meta: state.metaState.toJS(),
            feeds: state.feedsState.toJS(),
            viagf_nonce,
        }
    });
};

export const getStore = (form_id, feed_id, sobject) => {
    return $.getJSON(ajaxurl, {
        action: 'via_get_sf_field_map',
        form_id,
        feed_id,
        sobject,
        viagf_nonce,
    });
};
